import { IArticleData } from "../interfaces";

export const articleData = [
  {
    name: "Battle of Britain",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 1,
    imageSrc: "https://www.historyhit.com/app/uploads/2020/07/SpitIX611b-1.jpg",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
  {
    name: "Battle of Berlin",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 2,
    imageSrc:
      "https://warfarehistorynetwork.com/wp-content/uploads/2019/01/Q-Ste.Mere-4-HT-Fal11.jpg",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
  {
    name: "Cultural matters",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 3,
    imageSrc:
      "https://ichef.bbci.co.uk/news/976/cpsprodpb/F787/production/_124676336_great_yarmouth_ats_on_parade_iwm.jpg",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
  {
    name: "Oscar Schindler",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 4,
    imageSrc:
      "https://images.immediate.co.uk/production/volatile/sites/7/2018/01/BNPT4B-2-d2c8ad6.jpg?quality=90&resize=800,534",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
  {
    name: "Rise of Hitler",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 5,
    imageSrc:
      "https://cdn3.whatculture.com/images/2015/08/2.23734286-600x338.jpg",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
  {
    name: "Art of Blitzkrieg",
    description:
      "The primary objective of the German forces was to compel Britain to agree to a negotiated peace settlement. In July 1940...",
    articleId: 6,
    imageSrc:
      "https://media.vanityfair.com/photos/5f63dc187f3af093f328bf1a/7:3/w_1994,h_854,c_limit/Nazi-Germany-Trump-GOP.jpg",
    tags: ["Military", "Science"],
    upvotes: 118,
    downvotes: 11,
    author: "Martin Septim",
  },
] as IArticleData[];
